import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Button,
  Checkmark,
  Chevron,
  Icon,
} from '@resy/ui-kitchen';

const renderCheckmark = () => (
  <Icon
    name="Checkmark"
    className="Icon--Checkmark--green"
    component={Checkmark}
    height="20"
    width="20"
  />
);

const ReservationQuestion = ({
  additionalElements,
  children,
  id,
  isActive,
  isLoading,
  onClick,
  showCheckmark,
  showSeparator,
  subtitleText,
  titleText,
}) => (
  <div
    className={cx(
      'ReservationQuestionnaire__question',
      { skeleton: isLoading }
    )}
    id={`question-${id}`}
  >
    <div>
      <Button
        variant="no-style"
        className="ReservationQuestionnaire__question--header"
        onClick={onClick}
        type="button"
        aria-expanded={isActive}
      >
        <Icon
          name="Chevron"
          className={cx({ 'chevron--down': isActive })}
          component={Chevron}
        />
        <div className="ReservationQuestionnaire__question--title">
          {titleText}
        </div>
        {showCheckmark && renderCheckmark()}
        <div className="ReservationQuestionnaire__question--subtitle">
          {subtitleText}
        </div>
      </Button>
      {additionalElements && (
      <div
        className="ReservationQuestionnaire__question--additional-elements"
      >
        {additionalElements}
      </div>
      )}
    </div>
    {isActive && (
    <div className="ReservationQuestionnaire__question--body">
      {children}
    </div>
    )}
    {showSeparator && <hr className="ReservationQuestionnaire__separator" />}
  </div>
);

ReservationQuestion.propTypes = {
  additionalElements: PropTypes.node,
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  showCheckmark: PropTypes.bool,
  showSeparator: PropTypes.bool,
  subtitleText: PropTypes.string.isRequired,
  titleText: PropTypes.string.isRequired,
};

ReservationQuestion.defaultProps = {
  additionalElements: undefined,
  showCheckmark: false,
  showSeparator: false,
};

export default ReservationQuestion;
